/**
 * Created by Desarrollo KJ on 20/3/2017.
 */
import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {Configuration} from './config.service';
//import * as _ from "lodash";

@Injectable()
export class ApiService {

  private actionUrl: string;


  constructor(private _http: Http, private _configuration:Configuration) {
    this.actionUrl = this._configuration.ServerWithApiUrl;
  }


  //Paises
  public getPais(idPais){
    return this._http.get(this.actionUrl + 'paises/' + idPais, this._configuration.resquestOption)
      .map(res => res.json());
  }

  //Categorias y productos

  /**
   * Todas las categorias
   * @returns {Observable<R>}
   */
  public getAllCategory() {
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/categorias', this._configuration.resquestOption)
      .map(res => res.json());
  }

  /**
   * Informacion de una categoria
   * @param idCategoria
   * @returns {Observable<R>}
   */
  public getCategory(idCategoria: number) {
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/categorias/' + idCategoria, this._configuration.resquestOption)
      .map(res => res.json());
  }

  /**
   * Todos los productos
   * @returns {Observable<R>}
   */
  public getAllProductos() {
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/productos?perPage=99', this._configuration.resquestOption)
      .map(res => res.json());
  }


  /**
   * Todo los productos de una categoria
   * @param idCategoria
   * @returns {Observable<R>}
   */
  public getAllProductosByCategory(idCategoria: number) {
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/categorias/' + idCategoria + '/productos?perPage=99', this._configuration.resquestOption)
      .map(res => res.json());
  }

  /**
   * Informacion de un producto
   * @param idProducto
   * @returns {Observable<R>}
   */
  public getProducto(idProducto: number) {
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/productos/' + idProducto, this._configuration.resquestOption)
      .map(res => res.json());
  }

  /**
   * Informacion de varios productos en base a un array de IDs
   * @param idProductos
   * @returns {Observable<R>}
   */
  public getProductoMulti(idProductos: number[]) {
    let arrayProductos = '[' + idProductos.toString() + ']';
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/productos?idProducto=' + arrayProductos, this._configuration.resquestOption)
      .map(res => res.json());
  }

  //Gestion de usuario

  /**
   * Crear cliente
   * @param user
   * @returns {Observable<R>}
   */
  public postUser(user: any): any {
    return this._http.post(this.actionUrl + 'usuarios/', user, this._configuration.resquestOption).map(res => res.json());
  }

  /**
   * Editar cliente
   * @param user
   * @returns {Observable<R>}
   */
  public putUser(user: any): any {
    let userAux = {
      nombre:user.nombre,
      correo:user.correo,
      direccion:user.direccion,
      ciudad:user.ciudad
    }
    return this._http.put(this.actionUrl + 'usuarios/'+user.idUsuario, userAux, this._configuration.resquestOption).map(res => res.json());
  }


  /**
   * Log In
   * @param user
   * @returns {Observable<R>}
   */
  public postLogin(user: any): any {
    return this._http.post(this.actionUrl + 'login/', user, this._configuration.resquestOption).map(res => res.json());
  }

  /**
   * Actualizar contraseña
   * @param user
   * @returns {Observable<R>}
   */
  public postRecuperacion(user: any): any {
    return this._http.post(this.actionUrl + 'usuarios/recuperarCuenta/', user, this._configuration.resquestOption).map(res => res.json());
  }

  /**
   * Actualizar contraseña
   * @param user
   * @returns {Observable<R>}
   */
  public putPassword(user: any): any {
    let pass = {
      claveActual: user.claveActual,
      claveNueva: user.claveNueva
    };
    return this._http.put(this.actionUrl + 'usuarios/'+user.idUsuario+'/clave/', pass, this._configuration.resquestOption).map(res => res.json());
  }


  //Gestion de pagos

  /**
   * Obtener token de braintree
   * @returns {Observable<R>}
   */
  public getToken() {
    return this._http.get(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/pagos/generarToken', this._configuration.resquestOption)
      .map(res => res.json());
  }

  /**
   * Enviar pago
   * @param nonce
   * @param formaPago
   * @returns {Observable<R>}
   */
  public postTransaccion(nonce, formaPago): any {
    let user = JSON.parse(localStorage.getItem('login'));
    let productos = JSON.parse(localStorage.getItem('carrito'));
    let array: any = [];
    for (let index in productos) {
      array.push({id: index, cantidad: productos[index]});
    }
    let transaccion = {
      idUsuario: user.idUsuario,
      idProducto: array,
      nonce: nonce,
      formaPago:formaPago
    };
    return this._http.post(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/pagos/transaccion', transaccion, this._configuration.resquestOption).map(res => res.json());
  }

  /**
   * Enviar pago
   * @param nonce
   * @param formaPago
   * @returns {Observable<R>}
   */
  public postTransaccionMercadoPago(token, correo, tipoTarjeta): any {
    let user = JSON.parse(localStorage.getItem('login'));
    let productos = JSON.parse(localStorage.getItem('carrito'));
    let array: any = [];
    for (let index in productos) {
      array.push({id: index, cantidad: productos[index]});
    }
    let transaccion = {
      idUsuario: user.idUsuario,
      idProducto: array,
      formaPago:'Mercado Pago',
      metodo:tipoTarjeta,
      correo:correo,
      token:token
    };
    return this._http.post(this.actionUrl + 'paises/' + this._configuration.paisConfiguration.idPais + '/pagos/transaccion', transaccion, this._configuration.resquestOption).map(res => res.json());
  }





  /**
   * Información de una factura especifica
   * @returns {Observable<R>}
   */
  public getFacturas() {
    return this._http.get(this.actionUrl + 'facturas?perPage=99&sort=creacion:DESC', this._configuration.resquestOption)
      .map(res => res.headers);
  }

  /**
   * Listado de facturas de un cliente
   * @param idFactura
   * @returns {Observable<R>}
   */
  public getFacturasById(idFactura:number) {
    return this._http.get(this.actionUrl + 'facturas/'+idFactura, this._configuration.resquestOption)
      .map(res => res.json());
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/services/api.service.ts